import { NgModule } from '@angular/core';

import { TagEditorComponent } from './tag-editor.component';

/**
 * @ignore
 */
@NgModule({
  declarations: [TagEditorComponent],
  imports: [],
  exports: [TagEditorComponent]
})
export class NguixDashboardTagEditorComponentModule {}
